import React from 'react';

import './BusinessReport.scss';
import ReportDashboard from './BusinessReportDashboard';
import { isSuperUser } from '../../../utils/userRoles';

function Report() {
  if (!isSuperUser()) {
    return null;
  }

  return <ReportDashboard />;
}

export default Report;
